import { ChannelPayloadFilter, ViewStream } from "spyne";
import { CodeContainerExamplesHolder } from "./code-container-examples-holder";
import { CodeContainerDetailsText } from "./code-container-details-text";
import { CodeContainerExamplesLink } from "components/code-examples/code-container-examples-link";
import { CodeContainerPropertiesContent } from "components/code-examples/code-container-properties-content";
import { CodeContainerPropertiesBackground } from "components/code-examples/code-container-properties-background";

export class CodeContainerProperties extends ViewStream {
  constructor(props = {}) {
    props.id = "code-container-properties";
    props.class = "code-section properties";
    super(props);
  }

  addActionListeners() {
    // return nexted array(s)

    const { parentVsid, codeBlockId } = this.props;
    //console.log("THIS DETAILS VSID ",parentVsid);
    const isContainerFilter = new ChannelPayloadFilter({
      payload: (v) => v.vsid === parentVsid,
    });
    const isCodeBlockIdFilter = new ChannelPayloadFilter({
      payload: (v) => v.codeBlockId === codeBlockId,
    });

    return [
      [
        "CHANNEL_CODE_CONTAINER_UPDATE_EVENT",
        "onChannelCodeUpdate",
        isCodeBlockIdFilter,
      ],
      [
        "CHANNEL_CODE_CONTAINER_PROPERTIES_CONTENT_UPDATED",
        "setHeightAnim",
        isCodeBlockIdFilter,
      ],
    ];
  }

  setHeightAnim(e) {
    if (this?.props?.el === undefined) {
      return;
    }

    const { isStartPosition, height, propertiesContentId } = e.payload;

    if (isStartPosition === false) {
      //console.log('set height anim ',{isStartPosition, height, propertiesContentId}, e.payload)

      const setCssTxt = (num) => {
        if (this?.props?.el !== undefined) {
          this.props.el.style.cssText =
            num === undefined ? "" : `height:${num}px;`;
        }
      };

      const setNewHeight = () => {
        if (this?.props?.el !== undefined) {
          const newHeight = this.props
          .el$(propertiesContentId)
          .el.getBoundingClientRect().height;
          setCssTxt(newHeight);
        }

      };
      const resetCssStr = () => setCssTxt();


      setNewHeight();

      window.setTimeout(resetCssStr, 1200);
    }
  }

  onChannelCodeUpdate(e) {
    if (this === undefined || this.props === undefined) {
      return;
    }

    const data = e.payload;
    const { properties } = data;
    const { parentVsid, codeBlockId } = this.props;

    const currentHeight = this.props.el.getBoundingClientRect().height;

    if (properties !== undefined) {
      this.props.el.style.cssText = `height: ${currentHeight}px`;
      this.appendView(
        new CodeContainerPropertiesContent({ data, parentVsid, codeBlockId }),
      );
    }
  }

  broadcastEvents() {
    // return nexted array(s)
    return [];
  }

  loadBackground() {
    const { parentVsid, codeBlockId } = this.props;
    this.prependView(
      new CodeContainerPropertiesBackground({ parentVsid, codeBlockId }),
    );
  }

  onRendered() {
    this.loadBackground();

    //this.appendView(new CodeContainerExamplesHolder())
    this.addChannel("CHANNEL_CODE_CONTAINER");
  }
}
